import { Station } from '@app/core/types/stations';
import {
  auditMentionsAuditMentionsDateSchedulesCsvImport,
  auditMentionsAuditMentionsDateSchedulesCsvValidate,
} from '@mi-front/api-v2';
import { ValidateAndUploadView } from '../../../../../../../../components/validate-upload-view/ValidateAndUploadView';
import { MentionsSchedulesPreview } from './MentionsSchedulesPreview';

/**
 * Builds multipart FormData for mention date-schedules CSV endpoints.
 */
function csvFileFormData(file: File) {
  const data = new FormData();
  data.append('file', file);
  return data;
}

/**
 * Validate + import mention date schedules CSV via api-v2.
 */
export function MentionsSchedulesCsvUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadView
      allowedExtensions={['.csv']}
      validateFn={(file: File) =>
        auditMentionsAuditMentionsDateSchedulesCsvValidate(
          { station: station.id },
          { data: csvFileFormData(file) },
        )
      }
      importFn={(file: File) =>
        auditMentionsAuditMentionsDateSchedulesCsvImport(
          { station: station.id },
          { data: csvFileFormData(file) },
        )
      }
      renderPreview={(data) => <MentionsSchedulesPreview data={data} />}
    />
  );
}
